module.exports = __webpack_public_path__ + "static/media/icono_pasta.cd99722a.png";